//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AV from "leancloud-storage";
import { Quiz, QuizResult } from "@/models";
import QuizQuestionResultItem from "@/components/quiz/quiz_question_result/QuizQuestionResultItem.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MyQuizResult",
  async created() {
    let quizResultId = this.$route.params.id;
    if (!quizResultId) {
      return;
    }

    let myResult = await QuizResult.getById(quizResultId);
    let quizId = myResult.get("quiz").id;
    this.myResult = myResult;
    this.quiz = this.myResult.get("quiz");

    this.initWechatShare();

    let openId = this.$route.query.openId;
    if (openId) {
      this.updateOpenId(openId);
    }

    try {
      this.didReceiveRedPacketForQuiz = await AV.Cloud.run(
        "checkDidReceiveRedPacketForQuiz",
        { quizId: quizId }
      );
    } catch (err) {}

    this.questionResults = await Quiz.getMyQuizQuestionResults(
      quizId,
      this.myResult.id
    );

    let action = this.$route.query.action;
    if (action == "getRedPacket") {
      this.getRedPacket();
    }
  },
  props: [],
  data() {
    return {
      quiz: null,
      myResult: null,
      questionResults: [],
      didReceiveRedPacketForQuiz: false,
    };
  },
  methods: {
    ...mapMutations(["updateOpenId"]),

    getRedPacketCover() {
      if (
        !this.quiz ||
        !this.quiz.get("presentRedPacketCover") ||
        !this.quiz.get("redPacketCoverUrl") ||
        !this.myResult ||
        this.myResult.get("highlight")
      ) {
        return;
      }

      window.open(this.quiz.get("redPacketCoverUrl"));
    },

    async getRedPacket() {
      if (this.didReceiveRedPacketForQuiz) {
        return;
      }

      if (!this.myResult) {
        return;
      }

      // 获取 openId
      if (!this.openId) {
        this.logInByWechat();
        return;
      }

      try {
        await AV.Cloud.run("receiveRedPacketForQuiz", {
          quizResultId: this.myResult.id,
          openId: this.openId,
        });

        this.$vux.toast.show({
          text: "红包领取成功",
          type: "text",
          position: "middle",
        });
        this.didReceiveRedPacketForQuiz = true;
      } catch (err) {
        this.$vux.toast.show({
          text: `红包已领完 ${err}`,
          type: "text",
          position: "middle",
        });
      }
    },

    logInByWechat() {
      let url = new URL(window.location.href);
      url.searchParams.set("action", "getRedPacket");
      window.location = `http://m.xczim.com/get-open-id?from=${url.href}`;
    },

    initWechatShare() {
      this.$initWechat().then(() => {
        this.$initWechatShare({
          title: this.quiz.get("title") + " · 西窗烛",
          link: "http://m.xczim.com/quiz/" + this.quiz.id,
          image: this.quiz.get("coverForShare")
            ? this.quiz.get("coverForShare").url()
            : "http://ac-9pq709je.clouddn.com/0aa50e161e586f7fb105.png",
          desc: "快来测测你的诗词量吧！",
        });
      });
    },

    isWeixin() {
      return this.userAgent.indexOf("micromessenger") >= 0;
    },

    // 是否可以领取微信红包封面
    canReceiveRedPacketCover() {
      return (
        this.quiz.get("presentRedPacketCover") &&
        this.myResult &&
        this.myResult.get("highlight") &&
        this.quiz.get("redPacketCoverUrl") &&
        this.isWeixin()
      );
    },

    // 是否可以领取微信现金红包
    canReceiveRedPacket() {
      return (
        this.quiz.get("presentRedPacket") &&
        this.myResult &&
        this.myResult.get("correctness") == 1 &&
        this.myResult.get("duration") >= 5 &&
        this.isWeixin()
      );
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: null,
    };
  },
  computed: {
    ...mapGetters(["user", "openId"]),
    title: function () {
      return (this.quiz ? this.quiz.get("title") : "诗词测验") + " · 西窗烛";
    },
    userAgent() {
      return window.navigator.userAgent.toLowerCase();
    },
  },
  components: {
    QuizQuestionResultItem,
  },
};



// WEBPACK FOOTER //
// ./src/pages/quiz/MyQuizResult.vue